import React from 'react';
import styles from './avatar-stack.module.scss';
import { decodeBase64ToImage } from '../../utils/helper';
const displayLimit = 5; // Limit the number of images displayed

export const AvatarStack = (props) => {
  const { data, total } = props;
  if (!data || data.length === 0) return <></>;
  return (
    <div className="d-flex">
      {data?.slice(0, displayLimit).map((val, index) => (
        <>
          <img
            alt="avatar"
            key={index}
            src={decodeBase64ToImage(val)}
            width={32}
            className={styles.image}
            style={{
              marginLeft: index === 0 ? 0 : '-10px',
              zIndex: 10 - index,
              position: 'relative',
            }}
          />
        </>
      ))}
      {total > displayLimit && <div className={styles.moreImages}>+{total - displayLimit}</div>}
    </div>
  );
};
export default AvatarStack;
